import { render, staticRenderFns } from "./zasady.vue?vue&type=template&id=efe5bfe6&"
import script from "./zasady.vue?vue&type=script&lang=js&"
export * from "./zasady.vue?vue&type=script&lang=js&"
import style0 from "./zasady.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "zasady.vue"
export default component.exports